import { render, staticRenderFns } from "./ColdStorageTemRight.vue?vue&type=template&id=54566738&scoped=true&"
import script from "./ColdStorageTemRight.vue?vue&type=script&lang=js&"
export * from "./ColdStorageTemRight.vue?vue&type=script&lang=js&"
import style0 from "./ColdStorageTemRight.vue?vue&type=style&index=0&id=54566738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54566738",
  null
  
)

export default component.exports